import { render, staticRenderFns } from "./ConfirmBack.vue?vue&type=template&id=61b71409&"
import script from "./ConfirmBack.vue?vue&type=script&lang=ts&"
export * from "./ConfirmBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports